import React, { useEffect, useState } from "react";
// import { Card, CardHeader, Container, Row } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  Row,
  Col,
} from "reactstrap";
import { Table, Collapse } from "reactstrap";

const TutorsReplacementAll = () => {
  return (
    <>
      <Container className="pt-7" >
        {/* <Row>
          <div className="col"> */}
            <Card className="shadow">
              <CardHeader style={{ height: "80px" ,display:"flex",flexDirection:"row"}}>
                <Col>
                  <h3 className="mb-0">Tutor's Replacement Allotment</h3>
                </Col>

                <Col md={3}>
                  <FormGroup>
                    <Input id="forType" type="select" required>
                      <option> ShortList Tutors </option>
                      <option value="1">Tutors 1</option>
                      <option value="2">Tutors 1</option>
                    </Input>
                  </FormGroup>
                </Col>
              </CardHeader>
              <CardBody>
                <Form>
                  <div className="p-3">
                    <Row>
                      <Col md={4}>
                        <FormGroup>
                          <Label for="exampleEmail">Class Status</Label>
                          <Input id="forType" type="select" required>
                            <option> Class Status</option>
                            <option value="1">Hold </option>
                            <option value="2">Active</option>
                          </Input>
                        </FormGroup>
                      </Col>

                      <Col md={4}>
                        <FormGroup>
                          <Label for="exampleEmail">
                            Assign To. Other Tutors
                          </Label>
                          <Input id="forType" type="select" required>
                            <option> Select Tutors </option>
                            <option value="1">Tutors 1</option>
                            <option value="2">Tutors 1</option>
                          </Input>
                        </FormGroup>
                      </Col>

                      <Col md={4}>
                        <FormGroup>
                          <Label for="exampleEmail">
                            Remaining Hours to Assign
                          </Label>
                          <Input
                            type="number"
                            required
                            defaultValue={10}
                            placeholder=" Enter Remaining Hours to Assign"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginTop: "8px",
                      flexDirection: "row",
                    }}
                  >
                    <Button to="/admin/creditmapping/creditmapping-view" color="danger" tag={Link}>
                      Cancel
                    </Button>
                    {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
                    <Button
                      color="primary"
                      type="submit"
                      style={{ float: "right", marginLeft: "5%" }}
                    >
                      Save
                    </Button>
                    {/* )} */}
                  </div>
                </Form>
              </CardBody>
            </Card>
          {/* </div>
        </Row> */}
      </Container>
    </>
  );
};

export default TutorsReplacementAll;
